import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import LoadingContent from 'shared/components/LoadingContent';
import api from 'utils/api';
import { Link } from 'react-router';
import Modal from 'shared/components/Modal';
import PropTypes from 'prop-types';
import HForm, {
  MultiTreeSelectInput,
} from 'shared/containers/portal_layout/HForm';
import { inlineReduxForm } from 'utils/reduxFormWrapper';
import { decamelizeKeys } from 'humps';
import { Badge } from 'preferral-ui/components/Badge';

const userStatusColors = {
  Pending: 'indigo',
  Denied: 'red',
  Active: 'green',
  Suspended: 'orange',
  Inactive: 'gray',
};

const Wrapper = (props) => {
  return (
    <Page title="Users">
      <Row>
        <Widget title="Users" span={12}>
          <IndexPage {...props} />
        </Widget>
      </Row>
    </Page>
  );
};

export default Wrapper;

class IndexPage extends Component {
  constructor() {
    super();
    this.state = { openModal: null, users: null };
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleSuccessfulModal = this.handleSuccessfulModal.bind(this);
  }

  hideModal() {
    this.setState({ openModal: null });
  }

  showModal(name, userId) {
    this.setState({ openModal: name, userId });
  }

  handleSuccessfulModal() {
    this.refresh();
    this.hideModal();
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    api
      .get(
        `/agent_portal/api/organizations/${this.props.params.organization_id}/users`
      )
      .then((response) => {
        this.setState({ users: response.data });
      });
  }

  render() {
    if (!this.state.users) return <LoadingContent />;

    const user = this.state.users.find((user) => user.id === this.state.userId);

    return (
      <div>
        <Modals
          user={user}
          handleSuccess={this.handleSuccessfulModal}
          hideModal={this.hideModal}
          openModal={this.state.openModal}
        />
        <table
          className="table-bordered table-striped table"
          data-spec-id="users"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Role</th>
              <th>Practices/Locations</th>
              <th>Logins</th>
            </tr>
          </thead>
          <tbody>
            {this.state.users.map((user) => (
              <tr key={user.id} data-spec-id={`row-${user.id}`}>
                <td>
                  <div className="flex items-center">
                    <Link to={`/a/portal/staff_employments/${user.id}`}>
                      {user.name}
                    </Link>
                    <Badge
                      className="ml-3"
                      color={userStatusColors[user.status]}
                    >
                      {user.status}
                    </Badge>
                  </div>
                </td>
                <td>{user.roleName}</td>
                <td>
                  {user.entityNames.join(', ')} (
                  <span
                    className="fake-link"
                    onClick={() => this.showModal('mappings', user.id)}
                  >
                    Change
                  </span>
                  )
                </td>
                <td>
                  <Link to={`/a/portal/agents/${user.agentId}/login_attempts`}>
                    Logins
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Link
          to={`/a/portal/organizations/${this.props.params.organization_id}/users/new`}
          className="btn btn-primary"
        >
          Add User
        </Link>
      </div>
    );
  }
}

const Modals = (props) => {
  if (!props.user) return null;
  return (
    <Modal show={props.openModal === 'mappings'} onHide={props.hideModal}>
      <StaffEmploymentMappings
        staffEmployment={props.user}
        handleSuccess={props.handleSuccess}
      />
    </Modal>
  );
};

Modals.propTypes = {
  handleSuccess: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
};

class StaffEmploymentMappings extends Component {
  constructor() {
    super();
    this.state = { entities: null };
    this.updateMappings = this.updateMappings.bind(this);
  }

  componentDidMount() {
    this.fetchEntities();
  }

  updateMappings(formValues) {
    api
      .put(
        `/agent_portal/api/staff_employments/${this.props.staffEmployment.id}/staff_mappings`,
        decamelizeKeys(formValues)
      )
      .then((response) => {
        this.props.handleSuccess();
      });
  }

  fetchEntities() {
    api.get(`/agent_portal/api/current_employment`).then((response) => {
      this.setState({ entities: response.data.mappedEntities });
    });
  }

  render() {
    if (!this.state.entities) return <LoadingContent />;
    const { staffEmployment } = this.props;
    return inlineReduxForm(
      {
        form: 'createAgent',
        initialValues: { mappedEntityIds: staffEmployment.mappedEntityIds },
      },
      (formProps) => (
        <HForm
          onSubmit={formProps.handleSubmit(this.updateMappings)}
          className="agent-creation"
        >
          <div className="modal-header">
            Edit Practices/Locations for {staffEmployment.name}
          </div>
          <div className="modal-body" style={{ width: 500, padding: '1rem' }}>
            <p>
              Click the names of the practices/locations you'd like map{' '}
              <b>{staffEmployment.name}</b> to. When you've finished selecting,
              click "Update".
            </p>
            <p>
              Practices/locations that the user has access to are highlighted{' '}
              <span
                style={{
                  backgroundColor: '#cbdff9',
                  borderRadius: 3,
                  padding: '0.25rem',
                  display: 'inline-block',
                  fontWeight: 'bold',
                }}
              >
                blue
              </span>
              .
            </p>
            <div
              style={{
                padding: '0.5rem',
                margin: '1.5rem 0 0.5rem',
                border: '1px solid #eee',
                borderRadius: '0.5rem',
                boxShadow: '0 1px 5px rgba(0,0,0,0.1)',
              }}
            >
              <MultiTreeSelectInput
                name="mappedEntityIds"
                label="Locations/Organizations"
                options={this.state.entities}
                subOptionsKey="children"
                valueKey="id"
                labelKey="name"
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </HForm>
      )
    );
  }
}

StaffEmploymentMappings.propTypes = {
  staffEmployment: PropTypes.object.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};
